export const SIDEBAR_COLLAPSED_WIDTH = 64;
export const SIDEBAR_EXPANDED_WIDTH = 190;
export const SUBSIDEBAR_WIDTH = 180;
